import styled from 'styled-components';

export const Main = styled.div`
  display: flex;
  height: 100vh;
`;

export const SecondColumn = styled.div`
  background-color: var(--vo-mist);
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  flex: 1;
  min-width: 0;
  position: relative;
  margin-left: 256px;
  padding-top: 64px;
  transition: margin-left 200ms cubic-bezier(.4,0,.2,1);

  footer{
    margin-top: auto;
  }

  &.menu-close {
    margin-left: 64px;
  }

  &.menu-open {
    margin-left: 256px;
  }

  @media(width <= 1200px){
    width: 100vw;
    max-width: 100vw;
    margin-left: 0;
    padding-top: 64px;

    &.menu-close,
    &.menu-open {
      margin-left: 0;
    }
  }
`